'use client';

import { c as _c } from "react/compiler-runtime";
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { createContext, useContext, useState } from 'react';
import { useTableFilters } from './use-table-filters.ts';
import { useTableSorting } from './use-table-sorting.ts';
import { useTableUserSettings } from './use-table-user-settings.ts';
export const TableStateContext = createContext({});
export const TableStateProvider = ({
  children,
  columns,
  initialColumnVisibility = {}
}) => {
  'use no memo';

  const [data, setData] = useState([]);
  const {
    filters,
    setFilters
  } = useTableFilters();
  const {
    setSorting,
    sorting
  } = useTableSorting({
    data
  });
  const [columnVisibility, setColumnVisibility] = useState(initialColumnVisibility);
  const [pageCount, setPageCount] = useState(0);

  // Create the table instance
  const table = useReactTable({
    columns,
    data,
    defaultColumn: {
      enableColumnFilter: false,
      enableHiding: true,
      enableSorting: false,
      size: 100
    },
    enableMultiSort: false,
    getCoreRowModel: getCoreRowModel(),
    manualPagination: true,
    manualSorting: true,
    onColumnFiltersChange: setFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onSortingChange: setSorting,
    pageCount,
    state: {
      columnFilters: filters,
      columnVisibility,
      sorting
    }
  });
  useTableUserSettings({
    columnVisibility,
    setColumnVisibility,
    table
  });
  return <TableStateContext.Provider value={{
    // @ts-expect-error
    columns,
    columnVisibility,
    setColumnVisibility,
    // @ts-expect-error
    setData,
    setPageCount,
    setSorting,
    sorting,
    // @ts-expect-error
    table
  }}>
      {children}
    </TableStateContext.Provider>;
};

// Custom hook to access the table state context
export const useTableState = () => {
  const context = useContext(TableStateContext);
  if (!context) {
    throw new Error("useTableState must be used within a TableStateProvider");
  }
  return context;
};